import ProductCategoryList from '@/data/productCategory/view/list.vue'

const list = {
  path: '/productCategory',
  name: 'productCategory-list',
  component: ProductCategoryList
}

export default [list]
